module.exports = __webpack_public_path__ + "static/media/proximanova-regular-webfont.ef7e7157.woff2";